var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{shadowy: _vm.shadowy, 'sub-title': _vm.subTitle}},[_c('div',{staticClass:"head",on:{"click":function($event){return _vm.clicked($event)}}},[_vm._t("head")],2),_vm._v(" "),_c('div',{staticClass:"body",class:{active: _vm.open}},[_vm._t("body")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-555d8e46","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion.vue
// module id = null
// module chunks = 